// extracted by mini-css-extract-plugin
export default {"howToSectionWrapper":"styles_howToSectionWrapper__dEXxJ","navList":"styles_navList__Nt3jo","backdrop":"styles_backdrop__lAFb2","modalFadeOut":"styles_modalFadeOut__mCAfH"};